import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes } from '../../routes';

interface ShareModalProps {
    processId: string;
    swimlaneId: string;
    theme?: 'dark' | 'light';
    linkBasePath: string; // Exemple: '/mapping'
}

const ShareModal: React.FC<ShareModalProps> = ({
    swimlaneId,
    processId,
    theme = 'dark',
    linkBasePath,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [copySuccess, setCopySuccess] = useState(false);
    const { t } = useTranslation();

    const baseUrl = window.location.origin;
    const shareLink = `${baseUrl}${Routes.MAPPING}${linkBasePath}`;

    const copyToClipboard = () => {
        if (inputRef.current) {
            inputRef.current.select();
            document.execCommand('copy');
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 3000);
        }
    };

    return (
        <div
            className="modal fade"
            id={`shareModal${swimlaneId}`}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div
                    className={`modal-content py-4 px-3 border-0 ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'
                        }`}
                >
                    <div className="modal-header d-flex justify-content-between p-0 pb-3 mb-3">
                        <h5 className="mb-0 fs-5">{t('navigation.shareLink')}</h5>
                        <button className={`btn-close ${theme === 'dark' ? ' bg-white' : ''}`} data-bs-dismiss="modal" />
                    </div>

                    <div>
                        <div className="d-flex align-items-center border rounded-3 px-2 py-1 w-100">
                            <span className="material-icons me-2">{t('words.link')}</span>
                            <input
                                type="text"
                                ref={inputRef}
                                className={`form-control form-control-sm p-0 rounded-3 fw-light border-0 ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'
                                    }`}
                                value={shareLink}
                                readOnly
                            />
                            <button
                                className={`p-2 border-0 rounded-2 px-3 ms-1 ${theme === 'dark' ? 'bg-secondary text-white' : 'bg-primary text-white'
                                    }`}
                                onClick={copyToClipboard}
                            >
                                {copySuccess ? t('words.copied') : t('words.copy')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareModal;
